// Tab keys of the data quality page (`?tab=`). A light module for the route's search schema.
// External enrichment providers are deferred in v1 (docs/SCOPE-v1.md §2): no enrichment queue tab.
export const QUALITY_TABS = ['conflicts', 'duplicates', 'validation'] as const;
export type QualityTab = (typeof QUALITY_TABS)[number];
